<template>
  <div class="box">{{ text }}</div>
</template>

<script>
export default {
  name: "MainHalfTitle",
  props: {
    text: {type: String}
  }
}
</script>

<style scoped>
.box{
  text-align: center;
  font-size: var(--ecs-font-lg);
  color: #61005f;
  margin: clamp(1.5rem, 4vw, 3rem) auto;
  line-height: 1.3;
}

@media (orientation: landscape) and (max-height: 480px) {
  .box{
    margin: clamp(0.375rem, 1vw, 0.75rem) auto;
  }
}
</style>
